
import { defineComponent } from 'vue'
import Lowversion from '@/views/low.vue'
import { useStarXpCompat } from '@/utils/useStarTheme'

export default defineComponent({
  name: 'StarXpGate',
  components: { Lowversion },
  props: {
    na: { type: String, required: true }
  },
  setup() {
    const { highversion, xpTheme } = useStarXpCompat()
    return { highversion, xpTheme }
  }
})
